import { Skeleton } from "@headerhawk/ui";
import { UsageMeter } from "./usage-meter";
import { useUsage } from "@/lib/hooks/use-usage";

interface ConnectedUsageMeterProps {
  compact?: boolean;
}

/**
 * Usage meter connected to the usage data hook.
 * Shows a skeleton while loading.
 */
export function ConnectedUsageMeter({
  compact = false,
}: ConnectedUsageMeterProps) {
  const { data, isLoading, isError } = useUsage();

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-2 w-full" />
        <Skeleton className="h-3 w-32" />
      </div>
    );
  }

  // Don't show if error or no data
  if (isError || !data) {
    return null;
  }

  return (
    <UsageMeter
      reportCount={data.reportCount}
      limit={data.limit}
      percentUsed={data.percentUsed}
      periodEnd={data.periodEnd}
      status={data.status}
      compact={compact}
    />
  );
}
